module.exports = __webpack_public_path__ + "media/images/premium/premium-card-po-lb-a4fdb78aebd987d2854531f98c49885f.svg";